// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__eqxdb","right":"styles_right__bsc6W"};